//一些常量的定义，避免多处赋值，方便维护
const wechatAppid = "wx70dd623f59efd16f";
const loginUrl = "https://console.2163.cn/#/login";
const officalWebsite = "https://www.2163.cn/";
const userAgreement = "https://www.2163.cn/agreement";
const privacyPolicy = "https://www.2163.cn/privacy";
const trainNotice = "https://2163.cn/index/article/detail/id/22";
const liveNotice = "https://2163.cn/index/article/detail/id/24";
const appUpload = "https://www.2163.cn/download";
export {
    wechatAppid,
    loginUrl,
    officalWebsite,
    userAgreement,
    privacyPolicy,
    trainNotice,
    liveNotice,
    appUpload
}
